import { Link, useLocation } from 'react-router-dom'
import { getNavigation } from '../../../content/docs/config'
import { NavItem } from '../../../types/docs'

interface DocsSidebarProps {
  version: string
  lang: string
}

function DocsSidebar({ version, lang }: DocsSidebarProps) {
  const location = useLocation()
  const navigation = getNavigation(version)

  const isActive = (path: string, hasChildren: boolean = false) => {
    const fullPath = `/docs/${version}/${lang}${path}`
    // For items with children, check if current path starts with the item path
    if (hasChildren) {
      return location.pathname.startsWith(fullPath)
    }
    // For leaf items, do exact match
    return location.pathname === fullPath || location.pathname === `${fullPath}/`
  }

  const renderNavItem = (item: NavItem) => {
    const fullPath = `/docs/${version}/${lang}${item.path}`

    return (
      <div key={item.path} className='docs-nav-section'>
        <Link to={fullPath} className={`docs-nav-link ${isActive(item.path, !!item.children) ? 'active' : ''}`}>
          {item.title}
        </Link>

        {item.children && (
          <ul className='docs-nav-submenu'>
            {item.children.map(child => {
              const childPath = `/docs/${version}/${lang}${child.path}`
              return (
                <li key={child.path}>
                  <Link to={childPath} className={`docs-nav-link ${isActive(child.path) ? 'active' : ''}`}>
                    {child.title}
                  </Link>
                </li>
              )
            })}
          </ul>
        )}
      </div>
    )
  }

  return (
    <aside className='docs-sidebar'>
      <nav className='docs-nav'>{navigation.map(renderNavItem)}</nav>
    </aside>
  )
}

export default DocsSidebar
